import { guideHub } from '@/mocks/features';

export default function GuideHub() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
            Complete Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Sugargoo Complete Guide Hub
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our comprehensive collection of guides covering every aspect of the Sugargoo experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {guideHub.map((guide, idx) => {
            if (guide.internal) {
              return (
                <a
                  key={idx}
                  href={guide.slug}
                  className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
                >
                  <div className="w-full h-36 overflow-hidden">
                    <img
                      src={guide.imageUrl}
                      alt={guide.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex items-start gap-3 p-4">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
                      <i className={`${guide.icon} text-base`}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                        {guide.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-0.5">{guide.subtitle}</p>
                    </div>
                  </div>
                </a>
              );
            }
            return (
              <a
                key={idx}
                href={guide.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
              >
                <div className="w-full h-36 overflow-hidden">
                  <img
                    src={guide.imageUrl}
                    alt={guide.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex items-start gap-3 p-4">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
                    <i className={`${guide.icon} text-base`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                      {guide.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{guide.subtitle}</p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}